<template>
	<saas-login v-if="SAAS" ref="login"></saas-login>
	<seller-login v-else ref="login"></seller-login>
</template>

<script>
	import sellerLogin from './seller_login'
	import saasLogin from './saas_login'
	import {cryptoJs} from '@deanwu/vue-component-library'
	import {mapState} from 'vuex'
	
	export default {
		components: {
			sellerLogin,
			saasLogin
		}
	}
</script>

<style lang="stylus" scoped>
</style>
